module.exports = __webpack_public_path__ + "img/inform-management-un.62e91179.png";